import { render } from "./RegistrationCompensationTableRowComponent.vue?vue&type=template&id=5150f310&scoped=true"
import script from "./RegistrationCompensationTableRowComponent.vue?vue&type=script&lang=js"
export * from "./RegistrationCompensationTableRowComponent.vue?vue&type=script&lang=js"

import "./RegistrationCompensationTableRowComponent.vue?vue&type=style&index=0&id=5150f310&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5150f310"]])

export default __exports__